const AcademicPlanStatusIDs = {
    APPROVED: "f7156f99-af84-403f-8e54-7a0aba330bfc",
    NEW: "67f672b5-f7a1-4125-9727-7e712ab2919e",
    PENDING_ADVISOR: "24481091-b473-4b2f-8193-c245901eea82",
    PENDING_STUDENT: "6d1f8e4b-7fef-4148-81b5-18f2b5ed5bff",
};
export { AcademicPlanStatusIDs };
